import { render, staticRenderFns } from "./RecommendedDriver.vue?vue&type=template&id=67327e02&scoped=true&"
import script from "./RecommendedDriver.vue?vue&type=script&lang=js&"
export * from "./RecommendedDriver.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedDriver.vue?vue&type=style&index=0&id=67327e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67327e02",
  null
  
)

export default component.exports